module.exports = __webpack_public_path__ + "img/content_all.c9b09d55.svg";